// Default images for users who haven't uploaded their own.
// Admin can override them via /admin → Paramètres → Images par défaut.
import { imageVariant } from "@/lib/mediaUrl";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const FALLBACKS = {
  avatar_male: "/defaults/avatar-male.jpg",
  avatar_female: "/defaults/avatar-female.jpg",
  avatar_neutral: "/defaults/avatar-neutral.jpg",
  cover: "/defaults/cover-default.jpg",
};

let current = { ...FALLBACKS };

const resolve = (u) => (u && u.startsWith("/api/") ? BACKEND_URL + u : u);

export const setDefaultImages = (map) => {
  current = { ...FALLBACKS };
  Object.entries(map || {}).forEach(([k, v]) => { if (v) current[k] = v; });
};

// Images par défaut (admin) : mêmes variantes légères que les photos des membres (statique /defaults/… inchangé).
export const defaultAvatar = (gender, size = 48) =>
  imageVariant(resolve(gender === "male" ? current.avatar_male : gender === "female" ? current.avatar_female : current.avatar_neutral), size);

export const defaultCover = () => imageVariant(resolve(current.cover), 1280);

// Avatar affiché à `size` px CSS (défaut 48 : listes, fil, commentaires) → variante légère (128 px)
// au lieu de la photo 1920 px ; servi depuis le CDN quand il est configuré.
export const avatarSrc = (u, size = 48) => {
  if (!u) return defaultAvatar(undefined, size);
  if (u.avatar_url) return imageVariant(u.avatar_url, size);
  return defaultAvatar(u.gender, size);
};

export const DEFAULT_COVER = FALLBACKS.cover;
